import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './shared/components/login/login.component';
import { authGuardDashboard, authGuardLogin } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [authGuardLogin]
  },
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full'
  },
  {
    path: 'rider-dashboard',
    loadChildren: () => import('./pages/rider-dashboard/rider-dashboard.module').then( m => m.RiderDashboardPageModule),
    canActivate: [authGuardDashboard]
  },
  {
    path: 'job-history',
    loadChildren: () => import('./pages/job-history/job-history.module').then( m => m.JobHistoryPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then( m => m.WelcomePageModule),
    canActivate: [authGuardLogin]
  },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
